// **  Initial State
const initialState = {
  settings: {},
  tracking_requests: {},
  loading: false
}

export const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'APP_SETTINGS':
      return {
        ...state,
        settings: action.data
      }
    case 'APP_LOADING_START':
      return {
        ...state, tracking_requests: { ...state.tracking_requests, [action.payload.key ?? 'null']: { finished: action?.payload?.value?.finished ?? false, status: action?.payload?.value?.status ?? null, url: action.payload.key ?? 'null', loading: true } }, loading: true
      }
    case 'APP_LOADING_END':
      return {
        ...state, tracking_requests: { ...state.tracking_requests, [action.payload.key ?? 'null']: { finished: action?.payload?.value?.finished ?? true, status: action?.payload?.value?.status ?? null, url: action.payload.key ?? 'null', loading: false } }, loading: false
      }
    default:
      return state
  }
}
